import { useState, useEffect, useCallback } from "react";
import { Loader2, Wallet, RefreshCw, Server, AlertCircle } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/admin/ui";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const ProviderBalances = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/providers/balances").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="Saldo de proveedores" subtitle="Saldo disponible en cada panel SMM conectado"
        action={<Button onClick={load} disabled={loading} variant="outline" className="rounded-lg" data-testid="refresh-balances-btn"><RefreshCw className={`h-4 w-4 mr-1 ${loading ? "animate-spin" : ""}`} /> Actualizar</Button>} />

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-indigo-600" /></div>
      ) : items.length === 0 ? (
        <EmptyState icon={Server} text="No hay proveedores configurados." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p) => (
            <div key={p.id} className="bg-white rounded-xl border border-slate-200 p-5" data-testid={`balance-card-${p.id}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="h-9 w-9 rounded-lg bg-indigo-50 flex items-center justify-center"><Wallet className="h-4.5 w-4.5 h-5 w-5 text-indigo-600" /></div>
                  <h3 className="font-heading font-bold text-slate-900">{p.name}</h3>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-full ${p.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{p.active ? "Activo" : "Inactivo"}</span>
              </div>
              {p.error ? (
                <p className="text-sm text-rose-600 flex items-center gap-1.5" data-testid={`balance-error-${p.id}`}><AlertCircle className="h-4 w-4" /> {p.error}</p>
              ) : (
                <p className="font-heading font-extrabold text-2xl text-slate-900" data-testid={`balance-value-${p.id}`}>
                  {p.balance != null ? Number(p.balance).toLocaleString("es-PY", { maximumFractionDigits: 2 }) : "—"} <span className="text-sm font-medium text-slate-400">{p.currency}</span>
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProviderBalances;
